export function formatCurrency(n) {
  const v = Number(n) || 0;
  if (v >= 1e9) return `$${(v / 1e9).toFixed(2)}B`;
  if (v >= 1e6) return `$${(v / 1e6).toFixed(2)}M`;
  if (v >= 1e3) return `$${(v / 1e3).toFixed(0)}K`;
  return `$${Math.round(v).toLocaleString()}`;
}

export function formatNumber(n) {
  const v = Number(n) || 0;
  return v.toLocaleString();
}

export function formatPercent(n, digits = 1) {
  const v = Number(n) || 0;
  return `${v.toFixed(digits)}%`;
}

export function formatRelative(iso) {
  if (!iso) return '—';
  const t = new Date(iso).getTime();
  if (!Number.isFinite(t)) return '—';
  const seconds = Math.max(1, Math.round((Date.now() - t) / 1000));
  if (seconds < 60) return `${seconds}s ago`;
  const m = Math.round(seconds / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.round(h / 24)}d ago`;
}

export const REASON_LABELS = {
  too_short:              'Description too short',
  low_value:              'Low dollar value',
  non_it_likely:          'Non-IT likely',
  no_vendor_match:        'No vendor match',
  ambiguous_description:  'Ambiguous description',
};

export function labelReason(key) {
  return REASON_LABELS[key] || key;
}
